'use strict';

import * as Props from '../Props';

const angular = require('angular');

const HyperlinkProperties = {
    Basic: {
        'ControlType': 'Hyperlink',
        'Label': {
            name: 'label',
            selectedValue: 'Hyperlink',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe',
            isSelected:false
        },
        'Field Name': Props.getFieldName('Hyperlink'),
        'Data Field Name': Props.getDataFieldName('Hyperlink'),        
        'Value': {
            name: 'linkAddress',
            selectedValue: '',
            type: 'textbox',
            onClickFunction: 'existingDataField',
            addOnButton: 'fa fa-function',
            onChangeFunction: 'checkRequired',
            readonly:false,
            placeholder: 'https://www.abc.com'
        },
        'DisplayLabel': {
            name: 'displayLabel',
            selectedValue: 'Link to site',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe',
            onChangeFunction: 'checkRequired',
            isSelected:false
        },
        'DSName': {
            selectedValue: '',
            hidden: true
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        },
    },
    Display: {
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: {
        'font-style-group': {
            type: 'style-group',
            members: {
                'font-family': {
                    type: 'dd',
                    title: 'font.family',
                    selectedValue: 'Helvetica',
                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana']
                },
                'font-size': {
                    type: 'number',
                    title: 'font.size',
                    selectedValue: 14,
                    min: '1',
                    max: '99',
                    default: 16
                },
                'background-color': {
                    type: 'color-picker',
                    title: 'background.color',
                    selectedValue: '#ffffff',
                    icon: 'fa fa-paint-brush'
                }
            }
        },
        'style-group': {
            type: 'style-group',
            members: {
                'bold': {
                    type: 'btn-toggle',
                    title: 'bold',
                    icon: 'fa fa-bold',
                    selectedValue: false
                }, 'italic': {
                    type: 'btn-toggle',
                    title: 'italic',
                    icon: 'fa fa-italic',
                    selectedValue: false
                }, 'underline': {
                    type: 'btn-toggle',
                    title: 'underline',
                    icon: 'fa fa-underline',
                    selectedValue: false
                },
                'alignment': {
                    type: 'radio-btn',
                    selectedValue: 'left',
                    options: [{
                        value: 'left',
                        title: 'align.left',
                        icon: 'fa fa-align-left',
                        name: 'controlAlignment'
                    }, {
                        value: 'center',
                        title: 'align.center',
                        icon: 'fa fa-align-justify',
                        name: 'controlAlignment'
                    }, {
                        value: 'right',
                        title: 'align.right',
                        icon: 'fa fa-align-right',
                        name: 'controlAlignment'
                    }]
                },
                'font-color': {
                    type: 'color-picker',
                    title: 'font.color',
                    selectedValue: '#1d6bb3',
                    icon: 'fa fa-font'
                }
            }
        },
        'Name': {
            selectedValue: 'style',
            hidden: true
        }
    },
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: {
        Name: {
            selectedValue: 'Events',
            hideSection: false,
            hidden: true
        },
        load: angular.copy(Props.elementEventsObject).load,
        click: {
            name: 'onClick',
            type: 'event',
            selectedValue: '',
            xmlValue: '',
            onClickFunction: 'openCodeEditorDialog'
        },
    },
};

export default HyperlinkProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Hyperlink.ts